import ModelWhiteImg from './assets/img/model-white.png';

export const ProductsData = [
  {
    id: 1,
    type: 'Food',
    name: 'Rice',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685963283/Real-Estate/Apartments/AlpEch/utcgumi4setvbrmtzrp6.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685963424/Real-Estate/Apartments/AlpEch/xd1qdyekeceyuo2vrh6l.png',
    state: 'Ogun',
    price: '37000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967570/Real-Estate/Apartments/AlpEch/fzedtw42pfvucacgfiqe.png',
      name: 'Adekuti Lawson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 2,
    type: 'Fruit',
    name: 'Orange',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685963725/Real-Estate/Apartments/AlpEch/wyqu1wzcalhb8wgf38zk.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685963849/Real-Estate/Apartments/AlpEch/qdm4sdqos81kudll8cww.png',
    state: 'Ogun',
    price: '14000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967634/Real-Estate/Apartments/AlpEch/hzk05p2ngznzzu9bqxcb.png',
      name: 'Chike Johnson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 3,
    type: 'Fruit',
    name: 'Apple',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685963992/Real-Estate/Apartments/AlpEch/a9meao7capi6isb4wmts.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964071/Real-Estate/Apartments/AlpEch/xixsqpaxxtipmzagwehs.png',
    state: 'Ogun',
    price: '18000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967667/Real-Estate/Apartments/AlpEch/yzkhnmgqzfgc59ap0kqk.png',
      name: 'Olatunji Hameenah',
      phone: '0123 456 78910',
    },
  },
  {
    id: 4,
    type: 'Spicy',
    name: 'Yellow Pepper',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964158/Real-Estate/Apartments/AlpEch/cndogtmdhhfdv2upullq.jpg',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964223/Real-Estate/Apartments/AlpEch/lzehrsl92ikytg9c3l8w.jpg',
    state: 'Oyo',
    price: '40000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967667/Real-Estate/Apartments/AlpEch/yzkhnmgqzfgc59ap0kqk.png',
      name: 'Olatunji Hameenah',
      phone: '0123 456 78910',
    },
  },
  {
    id: 5,
    type: 'Vegetables',
    name: 'Cabbage',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964283/Real-Estate/Apartments/AlpEch/xuufmhru1mh4l73ufeyn.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964335/Real-Estate/Apartments/AlpEch/xkeci6wat1ef1qwsbwc1.jpg',
    state: 'Lagos',
    price: '7000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967634/Real-Estate/Apartments/AlpEch/hzk05p2ngznzzu9bqxcb.png',
      name: 'Chike Johnson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 6,
    type: 'Food',
    name: 'Maize Corn',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964419/Real-Estate/Apartments/AlpEch/e4wn9vqlgbfxhqas2yxc.jpg',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964473/Real-Estate/Apartments/AlpEch/bgzcox3ad5akiysid0ds.jpg',
    state: 'Oyo',
    price: '36000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967667/Real-Estate/Apartments/AlpEch/yzkhnmgqzfgc59ap0kqk.png',
      name: 'Olatunji Hameenah',
      phone: '0123 456 78910',
    },
  },
  {
    id: 7,
    type: 'Food',
    name: 'Yam',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964534/Real-Estate/Apartments/AlpEch/hreutq5rft2wak6ha4zg.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964589/Real-Estate/Apartments/AlpEch/ak6yvrfcuzjjq8lzg5fp.jpg',
    state: 'Ogun',
    price: '50000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967667/Real-Estate/Apartments/AlpEch/yzkhnmgqzfgc59ap0kqk.png',
      name: 'Olatunji Hameenah',
      phone: '0123 456 78910',
    },
  },
  {
    id: 8,
    type: 'Spicy',
    name: 'Onions',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964699/Real-Estate/Apartments/AlpEch/ygwpharfc1gjmybc70sx.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685964764/Real-Estate/Apartments/AlpEch/sn3s61kfwamfqpxeaaqm.jpg',
    state: 'Lagos',
    price: '30000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967634/Real-Estate/Apartments/AlpEch/hzk05p2ngznzzu9bqxcb.png',
      name: 'Chike Johnson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 9,
    type: 'Vegetables',
    name: 'Lettuce',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685965086/Real-Estate/Apartments/AlpEch/msibrnvojm5fm7anjtiu.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685965175/Real-Estate/Apartments/AlpEch/nkozagcna13isxxofclt.jpg',
    state: 'Lagos',
    price: '20000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967634/Real-Estate/Apartments/AlpEch/hzk05p2ngznzzu9bqxcb.png',
      name: 'Chike Johnson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 10,
    type: 'LiveStock',
    name: 'Cow',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685965245/Real-Estate/Apartments/AlpEch/mljqismhtzy4xppjez96.jpg',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685965318/Real-Estate/Apartments/AlpEch/a51qkbi2umf1yffd96xi.jpg',
    state: 'Oyo',
    price: '80000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967570/Real-Estate/Apartments/AlpEch/fzedtw42pfvucacgfiqe.png',
      name: 'Adekuti Lawson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 11,
    type: 'LiveStock',
    name: 'Chicken',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685965484/Real-Estate/Apartments/AlpEch/j0zstyxrludner4l3wao.jpg',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685965552/Real-Estate/Apartments/AlpEch/axwxvwhgqycfqvhczvrg.jpg',
    state: 'Ogun',
    price: '7000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967570/Real-Estate/Apartments/AlpEch/fzedtw42pfvucacgfiqe.png',
      name: 'Adekuti Lawson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 12,
    type: 'Fruit',
    name: 'Banana',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685965695/bhodz6dggiifczliwkfw.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685965765/je0dvivmcbd17dejzgau.jpg',
    state: 'Lagos',
    price: '30000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967634/Real-Estate/Apartments/AlpEch/hzk05p2ngznzzu9bqxcb.png',
      name: 'Chike Johnson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 13,
    type: 'Fruit',
    name: 'Grapes',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685965908/Real-Estate/Apartments/AlpEch/inwh0ysdltherxd4q4si.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685965955/Real-Estate/Apartments/AlpEch/yl9e40tt0fbylk7poczv.jpg',
    state: 'Lagos',
    price: '40000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967570/Real-Estate/Apartments/AlpEch/fzedtw42pfvucacgfiqe.png',
      name: 'Adekuti Lawson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 14,
    type: 'LiveStock',
    name: 'Ram',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685966036/Real-Estate/Apartments/AlpEch/qena2qn9um4unhizxt7n.jpg',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685966072/Real-Estate/Apartments/AlpEch/hkm9ostfhqkac3qhee81.jpg',
    state: 'Oyo',
    price: '120000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967634/Real-Estate/Apartments/AlpEch/hzk05p2ngznzzu9bqxcb.png',
      name: 'Chike Johnson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 15,
    type: 'Spicy',
    name: 'Chill Pepper',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685966338/Real-Estate/Apartments/AlpEch/ggvkbre3jt9oldhvwxgg.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685966423/Real-Estate/Apartments/AlpEch/u7ffzd7bytxinmaygvhl.jpg',
    state: 'Lagos',
    price: '45000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967667/Real-Estate/Apartments/AlpEch/yzkhnmgqzfgc59ap0kqk.png',
      name: 'Olatunji Hameenah',
      phone: '0123 456 78910',
    },
  },
  {
    id: 16,
    type: 'Vegetables',
    name: 'Tomatoes',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685966469/Real-Estate/Apartments/AlpEch/yinsekjyscef0iihrqnp.png',
    imageLg: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685966525/Real-Estate/Apartments/AlpEch/crjyo3yn8enklbwhnbcj.jpg',
    state: 'Lagos',
    price: '65000',
    agent: {
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685967570/Real-Estate/Apartments/AlpEch/fzedtw42pfvucacgfiqe.png',
      name: 'Adekuti Lawson',
      phone: '0123 456 78910',
    },
  },
];


export const menuItems= [
  {
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685828386/Real-Estate/Apartments/AlpEch/drmc3sirh5n4jtuswmce.png',
    name: 'Maize Corn',
    price: '₦30,000',
    description: 'Class aptent taciti ciosqu litora torquent per',
  },
  {
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685828351/Real-Estate/Apartments/AlpEch/ybxlxdxpiajf5fdvj6gp.png',
    name: '1 Basket of Pepper',
    price: '₦62,000',
    description: 'Class aptent taciti ciosqu litora torquent per',
  },
  {
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685828294/Real-Estate/Apartments/AlpEch/rlwelev9qplgebbhvvui.png',
    name: 'Chicken',
    price: '₦6,000',
    description: 'Class aptent taciti ciosqu litora torquent per',
  },
  {
    image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685828432/Real-Estate/Apartments/AlpEch/dvhhzjuxo1bqtu6yigoq.jpg',
    name: 'Bag of Rice',
    price: '₦37,000',
    description: 'Class aptent taciti ciosqu litora torquent per',
  },
]


export const testimonialData = {
  title: "what client's say ",
  subtitle: '1500+ statisfied clients',
  modelImg: ModelWhiteImg,
  slider: [
    {
      message:
        'AlpEch made healthy eating easy in my busy lifestyle. ',
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685828056/Real-Estate/Apartments/AlpEch/x19ol1m5hooyrv08bi7j.png',
      name: 'Adebara Biola',
      occupation: 'CEO of Great Style',
    },
    {
      message:
        'AlpEch reconnected me with natures goodness. ',
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685828083/Real-Estate/Apartments/AlpEch/hevxcrxaehvepbyadsaq.png',
      name: 'Ngozi Chika',
      occupation: 'Manager at TotalEngeries',
    },
    {
      message:
        'AlpEch customer service is expectional, always going above and beyond.',
      image: 'https://res.cloudinary.com/hameedah-images/image/upload/v1685828114/Real-Estate/Apartments/AlpEch/otjruxnxq15fudarhsvv.png',
      name: 'John David.',
      occupation: 'CEO of Delightful',
    },
  ],
};